import {
  registerWidget,
  DME,
  DMEData,
  dmeConfig,
  generalSettings,
} from "dmeditor";

export interface TrackEnitity {
  schools?: string;
  list: Array<any>;
}

const defaultList = [
  {
    name: "DEMO",
    city: "Test",
    image: {
      image: "https://images.unsplash.com/photo-1562774053-701939374585",
    },
  },
  {
    name: "DEMO",
    city: "Test",
    image: {
      image: "https://images.unsplash.com/photo-1562774053-701939374585",
    },
  },
  {
    name: "DEMO",
    city: "Test",
    image: {
      image: "https://images.unsplash.com/photo-1562774053-701939374585",
    },
  },
  {
    name: "DEMO",
    city: "Test",
    image: {
      image: "https://images.unsplash.com/photo-1562774053-701939374585",
    },
  },
];

const cities = [
  { name: "Las Vegas, NV", url: "#" },
  { name: "Jacksonville, FL", url: "#" },
  { name: "Colorado Springs, CO", url: "#" },
  { name: "Atlanta, GA", url: "#" },
  { name: "Bakersfield, CA", url: "#" },
  { name: "Houston, TX", url: "#" },
  { name: "Charlotte, NC", url: "#" },
  { name: "Saint George, UT", url: "#" },
  { name: "Riverside, CA", url: "#" },
  { name: "San Antonio, TX", url: "#" },
  { name: "Salinas, CA", url: "#" },
  { name: "Katy, TX", url: "#" },
  { name: "Tampa, FL", url: "#" },
  { name: "Tucson, AZ", url: "#" },
  { name: "Nashville, TN", url: "#" },
  { name: "Memphis, TN", url: "#" },
];

export const ExploreRender = (props: DME.WidgetRenderProps<TrackEnitity>) => {
  const {
    blockNode: { data },
  } = props;

  const { list = defaultList } = data;

  return (
    <div>
      <div className="relative md:h-[31rem] xl:h-96 py-4 md:py-10 xl:py-20 w-full bg-[#1d0741]">
        <div className="bg-zd-800 w-full xl:h-80 relative hidden xl:flex">
          {/* {cities.map((item) => (
            <a
              key={item.name}
              href="#"
              className="cursor-pointer no-underline text-white absolute top-3 left-14 xl:top-2 xl:left-3 text-sm text-zd-300 opacity-40"
            >
              {item.name}
            </a>
          ))} */}
          <a
            href="/web/20240601084545/https://zerodown.com/raleigh--nc"
            className="cursor-pointer no-underline text-white absolute top-3 left-14 xl:top-2 xl:left-3 text-sm text-zd-300 opacity-40"
            rel=""
          >
            Raleigh, NC
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/orlando--fl"
            className="cursor-pointer no-underline text-white absolute top-8 left-14 xl:top-8 xl:left-16 text-sm text-zd-300 opacity-50"
            rel=""
          >
            Orlando, FL
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/houston--tx"
            className="cursor-pointer no-underline text-white absolute xl:top-16 xl:left-16 text-2xl text-zd-300 opacity-80"
            rel=""
          >
            Houston, TX
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/boulder--co"
            className="cursor-pointer no-underline text-white absolute xl:top-24 xl:left-40 text-lg text-zd-300 opacity-70"
            rel=""
          >
            Boulder, CO
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/cambridge--ma"
            className="cursor-pointer no-underline text-white absolute xl:top-32 xl:left-12 text-xl text-zd-300 opacity-75"
            rel=""
          >
            Cambridge, MA
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/san-antonio--tx"
            className="cursor-pointer no-underline text-white absolute xl:top-40 xl:left-32 text-sm text-zd-300 opacity-40"
            rel=""
          >
            San Antonio, TX
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/las-vegas--nv"
            className="cursor-pointer no-underline text-white absolute xl:top-44 xl:left-1 text-xl text-zd-300 opacity-80"
            rel=""
          >
            Las Vegas, NV
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/memphis--tn"
            className="cursor-pointer no-underline text-white absolute xl:top-52 xl:left-32 text-xl text-zd-300 opacity-50"
            rel=""
          >
            Memphis, TN
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/fremont--ca"
            className="cursor-pointer no-underline text-white absolute xl:top-56 xl:left-3 text-xl text-zd-300 opacity-70"
            rel=""
          >
            Fremont, CA
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/fort-worth--tx"
            className="cursor-pointer no-underline text-white absolute xl:top-64 xl:left-44 text-lg text-zd-300 opacity-90"
            rel=""
          >
            Fort Worth, TX
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/boston--ma"
            className="cursor-pointer no-underline text-white absolute xl:top-5 xl:right-0 text-sm text-zd-300 opacity-60"
            rel=""
          >
            Boston, MA
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/tampa--fl"
            className="cursor-pointer no-underline text-white absolute xl:top-12 xl:right-40 text-sm text-zd-300 opacity-60"
            rel=""
          >
            Tampa, FL
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/phoenix--az"
            className="cursor-pointer no-underline text-white absolute text-xl xl:top-16 xl:right-12 text-zd-300 opacity-50"
            rel=""
          >
            Phoenix, AZ
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/baltimore--md"
            className="cursor-pointer no-underline text-white absolute xl:top-20 xl:right-40 text-lg text-zd-300 opacity-75"
            rel=""
          >
            Baltimore, MD
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/philadelphia--pa"
            className="cursor-pointer no-underline text-white absolute xl:top-28 xl:right-12 text-xl text-zd-300"
            rel=""
          >
            Philadelphia, PA
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/san-jose--ca"
            className="cursor-pointer no-underline text-white absolute xl:top-36 xl:right-44 text-xl text-zd-300 opacity-90"
            rel=""
          >
            San Jose, CA
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/new-york--ny"
            className="cursor-pointer no-underline text-white absolute xl:top-44 xl:right-1 text-2xl text-zd-300 opacity-80"
            rel=""
          >
            New York, NY
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/dallas--tx"
            className="cursor-pointer no-underline text-white absolute xl:top-52 xl:right-28 text-xl text-zd-300 opacity-60"
            rel=""
          >
            Dallas, TX
          </a>
          <a
            href="/web/20240601084545/https://zerodown.com/knoxville--tn"
            className="cursor-pointer no-underline text-white absolute xl:top-60 xl:right-44 text-lg text-zd-300 opacity-60"
            rel=""
          >
            Knoxville, TN
          </a>
        </div>
        <div className="md:absolute gap-x-5 bottom-1/4 mx-auto md:flex md:justify-center md:left-1/2 md:-translate-x-1/2 ">
          {list.map((school) => (
            <div key={school.city}>
              <div className="mx-auto rounded-xl flex flex-col text-white pb-7 w-[19rem] gap-y-3 overflow-hidden">
                <img
                  className="w-full h-48 object-cover inset-0 p-0 m-auto block min-w-full max-w-full min-h-full max-h-full box-border"
                  src={dmeConfig.general.imagePath(school?.image?.image || "")}
                />
                <div className="px-5 flex flex-col gap-y-3">
                  <div className="text-zd-600 text-lg font-semibold">
                    {school.city}
                  </div>
                  {/* <div className="min-h-20">
                    Craftsman homes dominate the landscape of beautiful Seattle.
                  </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-8 mx-auto w-9/12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 lg:grid-rows-2 xl:grid-cols-5 gap-x-16 lg:gap-x-20 gap-y-4 text-accent">
          {cities.map((city) => (
            <a
              href="#"
              className="cursor-pointer no-underline text-zd-800 dark:text-zd-400 hover:text-zd-600 dark:hover:text-zd-300 h-6 truncate text-zd-gradient font-medium flex items-center"
              rel=""
              key={city.name}
            >
              {city.name}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 512"
                width="1em"
                height="1em"
                fill="currentColor"
                className="mt-0.5 ml-1"
              >
                <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
              </svg>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default () => {
  registerWidget(
    {
      type: "mf-explore",
      icon: "matchfit",
      name: "Explore",
      category: "basic",
      settings: [
        {
          name: "Schools",
          property: ".schools",
          settingComponent: "input",
          description: "eg.1,2,3",
        },
        ...generalSettings,
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "mf-explore",
            data: {},
          };
        },
      },
    },
    {
      render: ExploreRender,
    }
  );
};
